import React from 'react';

import AppHeader from '../../../Layout/Header';
import FooterComponent from '../../../Layout/Footer';
import banner from '../../../Assets/Linkages/InternationalConferences/International-Conferences-Banner.jpg';
import '../../../Styles/Linkages&Outreach.css';
import InternationalConferencesIntroduction from './InternationalConferencesIntroduction';
import ICASTFeature from './ICASTFeature';
import ICASEFeature from './ICASEFeature';

const InternationalConferences = () => (
  <>
    <AppHeader />
    <main className="international-conferences-page">
      <section className="outreach-event-hero" aria-label="International Conferences">
        <img
          className="outreach-event-banner"
          src={banner}
          alt="International Conferences"
        />
      </section>
      <InternationalConferencesIntroduction />
      <ICASTFeature />
      <ICASEFeature />
    </main>
    <FooterComponent />
  </>
);

export default InternationalConferences;
